export default {
  to: "/reinstatement/list",
  order: 3,
  icon: "mdi-arrow-down-left-bold",
  title: "Reinstatement",
  disabled: false,
};
